import { BrainCircuit, TriangleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { Skeleton } from '@/components/ui/skeleton';
import { EmoviDocConversationItem } from './EmoviDocConversationItem';
import type { EmoviDocConversation } from './types';

type EmoviDocConversationListProps = {
  loading: boolean;
  error: string | null;
  conversations: EmoviDocConversation[];
  isCreatingConversation: boolean;
  isDeletingConversation: number | null;
  onRetry: () => void;
  onCreateConversation: () => void;
  onSelectConversation: (conversationId: number) => void;
  onDeleteConversation: (conversationId: number) => void;
};

export function EmoviDocConversationList({
  loading,
  error,
  conversations,
  isCreatingConversation,
  isDeletingConversation,
  onRetry,
  onCreateConversation,
  onSelectConversation,
  onDeleteConversation,
}: EmoviDocConversationListProps) {
  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-border">
        <Button
          type="button"
          variant="default"
          size="sm"
          className="w-full"
          isLoading={isCreatingConversation}
          onClick={onCreateConversation}
        >
          Nuova conversazione
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-2">
        {loading ? (
          <>
            <Skeleton className="h-12 w-full rounded-lg" />
            <Skeleton className="h-12 w-full rounded-lg" />
            <Skeleton className="h-12 w-full rounded-lg" />
          </>
        ) : null}

        {!loading && error ? (
          <EmptyState
            icon={<TriangleAlert className="h-8 w-8" />}
            title="Impossibile caricare le conversazioni"
            action={
              <Button type="button" size="sm" onClick={onRetry}>
                Riprova
              </Button>
            }
          />
        ) : null}

        {!loading && !error && conversations.length === 0 ? (
          <EmptyState
            icon={<BrainCircuit className="h-8 w-8" />}
            title="Nessuna conversazione"
            description="Inizia a esplorare i dati clinici del cliente."
            action={
              <Button type="button" size="sm" onClick={onCreateConversation}>
                Nuova conversazione
              </Button>
            }
          />
        ) : null}

        {!loading && !error && conversations.length > 0
          ? conversations.map((conversation) => (
              <EmoviDocConversationItem
                key={conversation.id}
                conversation={conversation}
                isDeleting={isDeletingConversation === conversation.id}
                onSelect={onSelectConversation}
                onDelete={onDeleteConversation}
              />
            ))
          : null}
      </div>
    </div>
  );
}
